<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-code`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.16 14.123L7.057 25.147 16.6 36.172a1 1 0 01-.037 1.35l-1.31 1.352a1 1 0 01-1.413.022l-.057-.06L2.388 25.822a1 1 0 01.015-1.335l11.976-13.065a1 1 0 011.315-.14l.12.1 1.328 1.37a1 1 0 01.019 1.372zm24.075 11.024L31.572 14.12a1 1 0 01.034-1.354l1.308-1.352a1 1 0 011.414-.022l.054.056 11.515 13.023a1 1 0 01-.012 1.338L33.91 38.871a1 1 0 01-1.412.062l-.043-.042-1.308-1.35a1 1 0 01-.018-1.371l10.105-11.024zM26.007 2.884l1.986.23a1 1 0 01.878 1.11l-4.769 41.013a1 1 0 01-1.109.877l-1.986-.23a1 1 0 01-.878-1.11l4.769-41.013a1 1 0 011.109-.877z"/></svg>
</template>
<script>

export default {
  name: 'IconCode',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
